import { gql } from '@apollo/client';
import type {
  checkCampaignBySlug,
  checkCampaignBySlugVariables,
} from '~/types/generated/cms/checkCampaignBySlug';
import { getDatoClient } from 'src/datoCMS/datoCmsClient';
import type { GetServerSideProps } from 'next';

const CHECK_CAMPAIGN_BY_SLUG = gql`
  query checkCampaignBySlug($slug: String) {
    allCampaigns(filter: { slug: { eq: $slug } }) {
      id
    }
  }
`;

/**
 * This is the catch-all root route
 * Currently solely used for redirecting to campaign pages, could also include others later
 * e.g. /my-cool-partner-landing-page => /campagne/my-cool-partner-landing-page
 *
 * It only redirects if there is a match in DatoCMS, otherwise it 404s
 */
const RootCatchAll: React.FC = () => {
  // Nothing to be rendered; just a redirect
  // Idea: Could also make this an API route instead perhaps?
  // - https://nextjs.org/docs/pages/building-your-application/routing/api-routes
  // - https://nextjs.org/docs/app/api-reference/functions/redirect
  return <></>;
};

export const getServerSideProps: GetServerSideProps = async ({ params, preview, query }) => {
  try {
    const client = getDatoClient(preview);

    const { data } = await client.query<checkCampaignBySlug, checkCampaignBySlugVariables>({
      query: CHECK_CAMPAIGN_BY_SLUG,
      variables: { slug: params?.slug as string },
      fetchPolicy: 'network-only',
    });

    if (!data.allCampaigns.length) {
      return { notFound: true };
    }

    // Preserve the query parameters (e.g. UTMs)
    const urlSearchParams = new URLSearchParams();
    for (const key in query) {
      if (key === 'slug') continue;
      urlSearchParams.append(key, query[key] as string);
    }
    const paramString = Object.keys(query).length ? `?${urlSearchParams.toString()}` : '';

    return {
      redirect: {
        destination: `/campagne/${params?.slug}${paramString}`,
        statusCode: 301,
      },
    };
  } catch (e) {
    console.error('Could not provide root redirect for slug', params?.slug, e);
    return { notFound: true };
  }
};

export default RootCatchAll;
